define(["require", "exports", "jquery", "knockout", "log", "../../utils/tools", "../../utils/kendoUtils"], function (require, exports, $, ko, log, tools, KendoUtils) {
    "use strict";
    var CdrActions = /** @class */ (function () {
        function CdrActions() {
            this.hasImportResults = ko.observable(false);
            this.importFinished = ko.observable(false);
            this.Provider = ko.observable('');
            this.CallType = ko.observable('');
        }
        CdrActions.prototype.init = function () {
        };
        CdrActions.prototype.openImportWindow = function (callback) {
            var self = this;
            self.hasImportResults(false);
            self.importFinished(false);
            tools.editModal({
                title: "Manual Call Detail Records Import",
                buttonTitle: 'Import',
                type: 'info',
                modalClass: 'full-width',
                modalOptions: {},
                save: function (event, modal) {
                    if ($(event.currentTarget).text() == 'Close') {
                        $(modal).modal('hide');
                        return;
                    }
                    //validate form
                    if (!self.Provider()) {
                        tools.error('Provider is required');
                        return;
                    }
                    if ($(".k-upload-selected").length < 1) {
                        tools.error('File is required');
                        return;
                    }
                    $(event.currentTarget).button('loading');
                    self.btn = event.currentTarget;
                    self.processImport(event.currentTarget, modal, callback);
                },
                opened: function (modal) {
                    // Get lookup data:
                    var getLookupData = tools.ajaxGet({
                        url: "/CallDetailRecord/ManualImportLookupData",
                        success: function (data) {
                            if (data.Success) {
                                self.lookupLists = data.Data.lookupLists;
                            }
                            else {
                                log.error(data.Error);
                            }
                        }
                    });
                    $.when(getLookupData).done(function (lookupData, data) {
                        $(modal).find('.modal-body').html("<div data-bind=\"template: { name: 'cdr-import-template', data: $root }\"></div>");
                        ko.applyBindings(self, modal);
                        self.importFileUpload = $("#fileupload", modal).kendoUpload({
                            async: {
                                saveUrl: "/CallDetailRecord/UploadImportFile",
                                autoUpload: false
                            },
                            select: function (e) {
                                $(e.sender.element).parents(".k-upload").find(".k-upload-files").remove();
                                setTimeout(function () {
                                    $(".k-upload-selected").hide();
                                }, 1);
                            },
                            complete: function (e) {
                                log.log(e);
                            },
                            success: function (e) {
                                var result = e.response;
                                self.hasImportResults(result.Success);
                                $(self.btn).button('reset');
                                self.importFinished(true);
                                if (result.Success) {
                                    self.importRegisterTable.refresh();
                                    $(self.btn).text('Close');
                                    if (callback) {
                                        callback();
                                    }
                                }
                                else {
                                    tools.error(result.Error);
                                }
                            },
                            upload: function (e) {
                                var data = {
                                    provider: self.Provider(),
                                };
                                e.data = data;
                            },
                            error: function (e) {
                                $(self.btn).button('reset');
                                tools.error(e.XMLHttpRequest ? e.XMLHttpRequest.statusText : "Unhanded error occurred");
                                self.importFinished(true);
                            }
                        });
                        self.initImportRegisterGrid(self.lookupLists.GridStructures.CdrImportRegisterStructure);
                    });
                }
            });
        };
        CdrActions.prototype.initImportRegisterGrid = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            self.importRegisterTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/CallDetailRecord/GetCdrImportRegisterRecords",
                            type: "POST",
                            data: function () {
                                var data = {};
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model
                    },
                    sort: { field: "ImportDate", dir: "desc" },
                    pageSize: 10
                },
                gridOptions: {
                    height: 300,
                    columns: columns
                },
                gridId: 'divCdrRegisterTable'
            };
            self.importRegisterTable.initGrid(gridOptions);
        };
        CdrActions.prototype.processImport = function (btn, modal, callback) {
            var self = this;
            self.hasImportResults(false);
            $(".k-upload-selected").click();
        };
        return CdrActions;
    }());
    return CdrActions;
});
//# sourceMappingURL=cdrActions.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/callDetailRecord/cdrActions.js
// module id = 249
// module chunks = 2